import { useEffect,useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import DialogTraiterInterruption from '../../../Components/Dialogs/DialogTraiterInterruption';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { StatutsMisionEnum } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
//import useSideBar from '../../../hooks/useSideBar';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getStatutMissionEnCoursSiDateDebutPasEncoreCommencee, searchLabelInEnumByValue, sortDate } from '../../../Utils/utils';

const InterruptionMission = () => {

    const [demandeInterruptionList, setDemandeInterruptionList] = useState();
    const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen } = useUtilities();
    const [demandesInterruption, setDemandesInterruption] = useState([]);
    const [rowselected,setRowSelected]=useState();
    const [openDialogValiderInterruption, setOpenDialogValiderInterruption] = useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const { i18n } = useTranslation();
    const columns = [
        { field: 'missionId',
            title: i18n.t('Réf. Mission'),

        },
        {
            field: 'titre',
            title: i18n.t('Intitulé'),

        },
        {
            field: 'demandeur',
            title: i18n.t('Demandeur'),

        },
        {
            field: 'typeDemandeur',
            title: i18n.t('Type Demandeur'),

        },
        {
            field: 'collaboratorId',
            title: i18n.t('Réf. Client'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du client'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'expertId',
            title: i18n.t('Réf. expert'),
            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),
            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateDemande',
            title: i18n.t('Date de demande'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateDemande)
            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début mission'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateDebutMission)
        },
        {
            field: 'statutMission',
            title: i18n.t('Statut'),
            render: rowData =>
                getStatutMissionEnCoursSiDateDebutPasEncoreCommencee(
                    searchLabelInEnumByValue(StatutsMisionEnum, (rowData?.statutMission)),
                    rowData?.dateDebutMission,
                    rowData?.isInterruptionEnCours
                ),
        },
        {
            field: 'motifInterruption',
            title: i18n.t('Motif d\'interruption'),
        },
        {
            field: 'dateEffective',
            title: i18n.t('Date effective (Souhaitée)'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateEffective)
        },
    ];

    useEffect(() => {
        getInterruptionMission();
        console.log(rowselected);
    },[]);

    useEffect(() => {
        if(demandeInterruptionList){
            let Array1=[];

            demandeInterruptionList?.forEach(element => {
                console.log('isinter',element?.interruptionClient?.isInterrupted,'test',element?.interruptionClient?.collaboratorId?.persoData);
                // if((element?.statutMission=='encours' && (element?.interruptionClient?.isInterrupted==false && element?.interruptionExpert?.isInterrupted==false )))
                Array1.push({
                    'id': element?._id,
                    'missionId': element?.missionId,
                    'titre': element?.titre,
                    'demandeur': element?.interruptionClient?.isInterrupted ? getNomPrenomClearFromPersoData(element?.interruptionClient?.collaboratorId?.persoData ?? element?.interruptionClient?.collaboratorEsnId?.persoData) : getNomPrenomClearFromPersoData(element?.interruptionExpert?.expertId?.persoData ?? element?.interruptionExpert?.collaboratorEsnId?.persoData),
                    'typeDemandeur':element?.interruptionClient?.isInterrupted ? 'Client' : 'Expert',
                    'dateDemande':element?.interruptionClient?.isInterrupted ? element?.interruptionClient?.dateInterruption : element?.interruptionExpert?.dateInterruption,
                    'Date':element?.interruptionClient?.isInterrupted ? element?.interruptionClient?.dateInterruption : element?.interruptionExpert?.dateInterruption,
                    'collaboratorId': element?.companyDataId?.clientId ??element?.esnId?.esnId,
                    'nomClient': element?.companyDataId?.profileEntreprise?.nom ?? element?.esnId?.profileEntreprise?.nom,
                    'expertId': element?.expertId?.expertId,
                    'nomExpert': getNomPrenomClearFromPersoData(element?.expertId?.persoData),
                    'dateEffectiveIso':element?.interruptionClient?.isInterrupted ? element?.interruptionClient?.dateEffective : element?.interruptionExpert?.dateEffective,
                    'dateEffective': element?.interruptionClient?.isInterrupted ? element?.interruptionClient?.dateEffective : element?.interruptionExpert?.dateEffective,
                    'dateDebutMission': element?.dateDebutMission,
                    'statutMission': element?.statutMission,
                    'isInterruptionEnCours': element?.interruptionClient?.isInterrupted || element?.interruptionExpert?.isInterrupted,
                    'motifInterruption':element?.interruptionClient?.isInterrupted ? element?.interruptionClient?.motifInterruption : element?.interruptionExpert?.motifInterruption,
                    //'dateValidationClient':element?.interruptionExpert?.nomExpert,
                });
            });
            setDemandesInterruption(sortDate(Array1));
        }
    },
    [demandeInterruptionList]
    );

    const getInterruptionMission = async () => {
        setBackdropOpen(true);
        try {
            console.log('HELLO FROM the get Missions useEffect');
            const response = await axiosPrivate.get('mission/getDemandesInterruptionMission', {
                // signal: controller.signal
            });
            console.log(response.data);
            setDemandeInterruptionList(response.data);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>

            <MaterialTableComponent
                data={demandesInterruption}
                columns={columns}
                title={i18n.t('Demande d`\'intteruption')}
                onRowClick={(event, rowData) => {
                    setSelectedRow(rowData?.tableData.id);
                    setRowSelected(rowData);
                    setOpenDialogValiderInterruption(true);
                }}
                // search={false}
                selectedRow={selectedRow}
            />

            <DialogTraiterInterruption
                handleCloseNestedInterruption={() => {
                    setOpenDialogValiderInterruption(false);
                }}
                getInterruptionMission={getInterruptionMission}
                interruption={rowselected}
                openNestedInttreption={openDialogValiderInterruption}
            />
        </>
    );
};

export default InterruptionMission;